import React, { lazy, Suspense, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { ToastContainer, Zoom } from "react-toastify";
import { loginAction } from "redux/action";
import { localStorage } from "core/helper";
import { useSelector } from "react-redux";

const PreLogin = lazy(() => import("../preLogin/preLogin"));
const PostLogin = lazy(() => import("../postLogin/postLogin"));

const Container = (props) => {
  const { loginAction } = props;
  const token = useSelector((state) => state?.account?.token);

  useEffect(() => {
    const token = localStorage.getAuthToken();
    if (token === "") {
      return false;
    }
    const user = localStorage.getAuthUser();
    loginAction({
      isLoggedIn: true,
      authUser: user?.authUser,
      token: token,
    });
  }, []);
  return (
    <Fragment>
      <Suspense
        fallback={
          <div id="global-loader">
            <img
              src="/assets/images/svgs/loader.svg"
              className="loader-img"
              alt="Loader"
            />
          </div>
        }
      >
        {token && <PostLogin />}
        {!token && <PreLogin />}
      </Suspense>
      <ToastContainer draggable={false} transition={Zoom} theme="dark" />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.account?.isLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginAction: (user) => dispatch(loginAction(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
